module.exports = __webpack_public_path__ + "static/media/art48.a54749d9.jpg";